var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('business-profile-page',[_c('business-wallet-account',{attrs:{"business":_vm.currentBusiness},on:{"wallet-account-created":_vm.accountCreated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }